import { Link } from 'react-router-dom';
import Icon from '../components/Icons';
import servicos from '../data/servicos';
import { SLUG_BRASILIA } from '../seo';
import './NaoEncontrada.css';

export default function NaoEncontrada() {
  return (
    <section className="nao-encontrada">
      <div className="container nao-encontrada__interno">
        <span className="rotulo">Erro 404</span>
        <h1>Esta página não existe</h1>
        <p>
          O endereço que você acessou pode ter sido alterado ou digitado
          incorretamente. Abaixo estão os caminhos mais procurados.
        </p>

        <div className="nao-encontrada__acoes">
          <Link className="btn btn--ouro" to="/">
            Voltar ao início
            <Icon name="seta" size={18} />
          </Link>
          <Link className="btn btn--contorno" to="/contato">
            Falar com o advogado
          </Link>
        </div>

        <ul className="nao-encontrada__links">
          {servicos.slice(0, 6).map((servico) => (
            <li key={servico.id}>
              <Link to={`/${servico.slug}`}>{servico.h1}</Link>
            </li>
          ))}
          <li>
            <Link to={`/${SLUG_BRASILIA}`}>Advogado Criminalista em Brasília</Link>
          </li>
        </ul>
      </div>
    </section>
  );
}
